// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3nXz6","list":"PatternAutocomplete_list__3ryb1"};